module.exports = __webpack_public_path__ + "fonts/BasierSquare-MediumItalic.e263d47.woff";